import { render } from "./inputPassword.vue?vue&type=template&id=54897412&scoped=true&ts=true"
import script from "./inputPassword.vue?vue&type=script&lang=ts"
export * from "./inputPassword.vue?vue&type=script&lang=ts"

import "./inputPassword.vue?vue&type=style&index=0&id=54897412&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54897412"]])

export default __exports__